import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  burguerIconContent: {
    padding: "16px 16px 0px 16px",
  },
}));

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0px 32px 0px;
`;

export const BrandContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-flow: row;
  span.slogan {
    font-size: 10px;
    line-height: 15px;
    width: 50px;
  }
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
`;
